import { useEffect, useState } from 'react'
import styles from './NovoDocEsp.module.css'
import TituloAssociado from '../Helper/TituloAssociado'
import Head from '../Helper/Head'
import Anexos from '../NovoAssociado/Anexos'
import { useFileContext } from '../../useFileContext'
import Button from '../Forms/Button'
import { CADASTRAR_DOC_ESP } from '../../api'
import { useUserContext } from '../../UserContext'
import UploadFiles from '../ServerSide/uploadToS3'
import Modal from 'react-modal'
import { useNavigate } from 'react-router-dom'

const NovoDocEsp = () => {
  const { uploadedFiles = [], setUploadedFiles, especialidade } = useFileContext()
  const { loading, setLoading, error, setError } = useUserContext();
  const [emailSent, setEmailSent] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const navigate = useNavigate();

  const fecharModal = () => {
    setEmailSent(false);
    navigate(-1)
  }


  async function handleSubmit(e: any) {
    e.preventDefault();
    try {
      if (uploadedFiles.length !== 0) {
        setLoading(true)
        const response = await UploadFiles(uploadedFiles, '', 'especialidades/' + especialidade[0].descricao)
        const docsResp = response?.map((item: any, index) => {
          return { url: item ? item.Location : '', nome_arquivo: item.Key };
        })
        if (!response) throw new Error('Erro ao enviar documento para a nuvem.')
        const { url, options } = CADASTRAR_DOC_ESP({
          id_especialidade: especialidade[0].id,
          url: docsResp ? docsResp[0].url : '',
          nome_arquivo: docsResp ? docsResp[0].nome_arquivo : ''
        })
        const data = await fetch(url, options);
        const { message } = await data.json();
        if (!data.ok) throw new Error(message);
        setMensagem(message)
        setEmailSent(true)
        setError(null)
      } else if (uploadedFiles.length === 0) {
        setError('Anexe o arquivo antes de continuar')
      }
    } catch (e: any) {
      console.log(e.message)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setUploadedFiles([])
    setError(null)
  }, [])

  return (
    <section className={`${styles.containerPrincipal} animeLeft`}>
      <TituloAssociado titulo={especialidade[0].descricao + ' - Novo Documento'} />
      <Head title='Área Gerencial - Novo Documento Especialidade' description='Área Gerencial' />
      <Modal
        className={styles.modal}
        isOpen={emailSent}
        onRequestClose={fecharModal}
        ariaHideApp={false}
      >
        <p>
          {mensagem}
        </p>
        <button onClick={fecharModal}>Fechar</button>
      </Modal>
      <div className={styles.divNovoDocEsp}>
        <form onSubmit={handleSubmit}>
          <div className={styles.divCampos}>
            <Anexos label={'Novo documento para - ' + especialidade[0].descricao} nome='NovoDocEsp' campo={0} accept={{
              'application/pdf': ['.pdf'],
              'text/plain': ['.txt'],
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            }} />

          </div>
          <Button classe='submit' descricao='enviar' disabled={loading} />
          <p className={styles.error}>{error}</p>
        </form>
      </div>
    </section>
  )
}

export default NovoDocEsp